import {BaseMyopMessage} from "../BaseMessage";
import {IMyopComponent} from "../../host";

type MethodNames<T> = {
    // [K in keyof T]: T[K] extends (...args: any[]) => any ? K : never;
    [K in keyof T]: T[K] extends () => void ? K : never;
}[keyof T];

// Define a type that allows only strings corresponding to the method names of T
type MethodString<T> = MethodNames<T> extends infer M ? M extends string ? M : never : never;


export class ExecuteComponentMethod extends BaseMyopMessage {
    messageType = 'ExecuteComponentMethod';

    constructor(public method: MethodString<IMyopComponent>) {
        super();
    }
}
